import flagSvgIcon from 'shared/svgs/flag_svg.jsx';
import allSvgIcon from 'shared/svgs/all_svg.jsx';
import returnSvgIcon from 'shared/svgs/return_svg.jsx';
import ndrSvgIcon from 'shared/svgs/ndr_svg.jsx';
import activeSvgIcon from 'shared/svgs/active_svg.jsx';
import apiSvg from 'shared/svgs/api_svg.jsx';
import downloadSvg from 'shared/svgs/download_svg.jsx';
import supportSvg from 'shared/svgs/support_svg.jsx';
import preferenceSvg from 'shared/svgs/preference_svg.jsx';
import walletSvg from 'shared/svgs/wallet_svg.jsx';
import retailerSvg from 'shared/svgs/retailer_svg.jsx';
import trackingPageSvg from 'shared/svgs/tracking_page_svg.jsx';
import userSvg from 'shared/svgs/user_svg.jsx';
import integrateSvg from 'shared/svgs/link_svg.jsx';
import invoicingSvg from 'shared/svgs/invoicing_svg.jsx';
import locationSvg from 'shared/svgs/location_sm_svg.jsx';
import shippingSvg from 'shared/svgs/shipping_package_svg.jsx';
import orderSvg from 'shared/svgs/order_svg.jsx';
import unserviceableSvg from 'shared/svgs/unserviceable_svg.jsx';
import missedSvg from 'shared/svgs/missed_svg.jsx';
import ndrCustomersSvg from 'shared/svgs/ndr_customer_svg.jsx';
import { insightsIconSvg } from '../../../../app/AppSeller/Insights/svgs/svgs.tsx';

export const ICON_MAPPER = {
	allSvgIcon: allSvgIcon,
	activeSvgIcon: activeSvgIcon,
	flagSvgIcon: flagSvgIcon,
	returnSvgIcon: returnSvgIcon,
	ndrSvgIcon: ndrSvgIcon,
	insightSvgIcon: insightsIconSvg,
	api: apiSvg,
	download: downloadSvg,
	support: supportSvg,
	preference: preferenceSvg,
	wallet: walletSvg,
	retailer: retailerSvg,
	tracking: trackingPageSvg,
	user: userSvg,
	integrate: integrateSvg,
	invoicing: invoicingSvg,
	location: locationSvg,
	shipping: shippingSvg,
	order: orderSvg,
	unserviceable: unserviceableSvg,
	missed: missedSvg,
	ndr2: ndrCustomersSvg
};
